"use strict";

exports.__esModule = true;
exports.ALL_VIEW_MODES = exports.VIEW_MODE_ONBOARDING = exports.VIEW_MODE_VIEWER = exports.VIEW_MODE_VIEWER_SEO = exports.VIEW_MODE_DASHBOARD = exports.VIEW_MODE_SITE = exports.VIEW_MODE_PREVIEW = exports.VIEW_MODE_EDITOR = void 0;
var VIEW_MODE_EDITOR = 'editor';
exports.VIEW_MODE_EDITOR = VIEW_MODE_EDITOR;
var VIEW_MODE_PREVIEW = 'preview';
exports.VIEW_MODE_PREVIEW = VIEW_MODE_PREVIEW;
var VIEW_MODE_SITE = 'site';
exports.VIEW_MODE_SITE = VIEW_MODE_SITE;
var VIEW_MODE_DASHBOARD = 'dashboard';
exports.VIEW_MODE_DASHBOARD = VIEW_MODE_DASHBOARD;
var VIEW_MODE_VIEWER_SEO = 'viewer-seo';
exports.VIEW_MODE_VIEWER_SEO = VIEW_MODE_VIEWER_SEO;
var VIEW_MODE_VIEWER = 'viewer';
exports.VIEW_MODE_VIEWER = VIEW_MODE_VIEWER;
var VIEW_MODE_ONBOARDING = 'onboarding';
exports.VIEW_MODE_ONBOARDING = VIEW_MODE_ONBOARDING;
var ALL_VIEW_MODES = [VIEW_MODE_EDITOR, VIEW_MODE_PREVIEW, VIEW_MODE_SITE, VIEW_MODE_DASHBOARD, VIEW_MODE_VIEWER_SEO, VIEW_MODE_VIEWER, VIEW_MODE_ONBOARDING];
exports.ALL_VIEW_MODES = ALL_VIEW_MODES;